import MenuComponent from '@/components/MenuComponent'
import ActualitesComponent from '@/components/ActualitesComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'
import { EntrepriseSearch } from '@/models/entreprisesearch.model'

export default {
  data () {
    return {
      adminRestricted: this.$store.state.user && this.$store.state.user.user && this.$store.state.user.user.restrictionsFilter && this.$store.state.user.user.restrictionsFilter.restrictionsItemsList.length,
      rechercheEntreprise: new EntrepriseSearch(),
      listEntreprises: [],
      paginatedListEntreprises: [],
      tooMuchResult: false,
      loading: false,
      searchDone: false,
      currentPage: 1,
      perPage: 20,
      totalItems: 0,
      pages: 1
    }
  },
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated,
    ActualitesComponent
  },
  methods: {
    async searchEntreprise () {
      this.searchDone = false
      this.loading = true
      this.$store.dispatch('entreprise/searchEntreprise', this.rechercheEntreprise).then(
        response => {
          this.loading = false
          this.tooMuchResult = false
          this.listEntreprises = response
          this.getPaginatedDatas()
          this.searchDone = true
        },
        error => {
          this.loading = false
          if (error && error.response && error.response.statusText) {
            if (error.response.statusText === 'Request Entity Too Large') {
              this.tooMuchResult = true
            }
            this.errorMessage = error.response.statusText
          }

          if (error && error.response && error.response.data) {
            this.listEntreprises = error.response.data
          }
          this.getPaginatedDatas()
          this.searchDone = true
        }
      )
    },
    setSelectedEntreprise (entreprise) {
      this.$store.dispatch('user/selectEntreprise', entreprise)

      this.$router.push({ name: 'entreprise/gestionnairedepenses' })
    },
    getPaginatedDatas () {
      // Gestion de la pagination
      if (this.listEntreprises) {
        this.totalItems = this.listEntreprises.length
        this.pages = Math.ceil(this.totalItems / this.perPage)
        this.putDatasInPaginatedList(0)

        if (this.pages < 1) {
          this.pages = 1
        }
      }
    },
    putDatasInPaginatedList (beginIndex) {
      this.paginatedListEntreprises = []
      beginIndex = this.perPage * beginIndex
      let endIndex = parseInt(beginIndex) + this.perPage
      if (this.listEntreprises.length <= this.perPage) {
        this.paginatedListEntreprises = this.listEntreprises
      } else {
        if (endIndex > this.listEntreprises.length) {
          endIndex = this.listEntreprises.length
        }
        for (let index = beginIndex; index < endIndex; index++) {
          this.paginatedListEntreprises.push(this.listEntreprises[index])
        }
      }
    },
    changeAvailablePage () {
      this.putDatasInPaginatedList(this.currentPage - 1)
    },
    getFilterValue (filterName) {
      if (this.adminRestricted) {
        for (let index = 0; index < this.$store.state.user.user.restrictionsFilter.restrictionsItemsList.length; index++) {
          if (this.$store.state.user.user.restrictionsFilter.restrictionsItemsList[index].filterName === filterName) {
            return this.$store.state.user.user.restrictionsFilter.restrictionsItemsList[index].restrictionItemsBase
          }
        }
      }
    }
  },
  beforeCreate () {
    // Push de la route pour enlever le lien de pagination dans l'url
    this.$router.push({ name: 'administration/adminrechercheentreprise' })

    this.$store.state.filArianePage = 'Recherche d\'entreprise'
    this.$store.state.filArianeMiddlePage = null
    this.$store.state.filArianeMiddleRouterLink = null
  },
  mounted () {
    if (this.adminRestricted) {
      for (let index = 0; index < this.$store.state.user.user.restrictionsFilter.restrictionsItemsList.length; index++) {
        if (this.$store.state.user.user.restrictionsFilter.restrictionsItemsList[index].filterName === 'SIRET') {
          this.rechercheEntreprise.siret = this.$store.state.user.user.restrictionsFilter.restrictionsItemsList[index].restrictionItemsBase
        }
        if (this.$store.state.user.user.restrictionsFilter.restrictionsItemsList[index].filterName === 'AGENCY_CODE') {
          this.rechercheEntreprise.agence = this.$store.state.user.user.restrictionsFilter.restrictionsItemsList[index].restrictionItemsBase
        }
        if (this.$store.state.user.user.restrictionsFilter.restrictionsItemsList[index].filterName === 'ENTITY_NAME') {
          this.rechercheEntreprise.raisonSociale = this.$store.state.user.user.restrictionsFilter.restrictionsItemsList[index].restrictionItemsBase
        }
      }
      this.searchEntreprise()
    }
  }
}
